<template>
    <v-app>
        <v-content>
            <v-layout row fill-height justify-center align-center>
                <v-flex md6 class="text-xs-center">
                    <Spinner/>
                    <span class="font-weight-bold display-1 description--color">Authorizing...</span>
                </v-flex>
            </v-layout>
        </v-content>
    </v-app>
</template>

<script>
	import Spinner from '@/components/Spinner'
    import {mapActions} from 'vuex';
	import moment from "moment";
	export default {
		props: ['code', 'error'],
		name: "Authorize",
		data() {
			return {
				url: process.env.VUE_APP_REDIRECT_URL
			}
		},
		components: {
			Spinner
		},
		methods: {
			...mapActions([
				'fetchAccessToken',
				'fetchUser'
			])
		},
		created() {
			// if (this.error === 'access_denied') window.location.href = `${this.url}/login`;
			// let accessTokenExpireTime = this.$session.get('atoken_expire_time') || 0;
			// if(moment(accessTokenExpireTime).diff(moment(), 'hours') <=0){
			// 	this.fetchAccessToken({code: this.code})
			// 		.then(_ => {
			// 			this.fetchUser()
			// 				.then(_ => {
			// 					this.$router.push({name: 'monitor-list'})
			// 				})
			// 		})
			// }else{
			// 	this.$router.push({name: 'monitor-list'})
			// }
			if (this.error === 'access_denied') window.location.href = `${this.url}/login`;
			this.fetchAccessToken({code: this.code})
				.then(_ => {
					this.fetchUser()
						.then(_ => {
							this.$router.push({name: 'monitor-list'})
						})
				})
		},
	}
</script>

<style scoped>

</style>
